import theme from '@css/theme';
import styled from 'styled-components';

export const Container = styled.div`
  background: #ffffff;
  border: 1px solid ${theme.color.border};
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  margin-bottom: 2rem;
`;

export const RecommendedTag = styled.span`
  margin-left: 1rem;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  background-color: ${theme.color.border};
  color: ${theme.color.neutral3};
`;
